import styled from '@emotion/styled';
import {Box} from "@mui/material";

interface RowProps {
    center?: boolean
    top?: boolean

}

export const Row = styled.div<RowProps>`
    display: flex;
    flex-direction: row;
    column-gap: 16px;
    ${(props: RowProps) => props.center ? "align-items: center;" : ""}
    ${(props: RowProps) => props.top ? "align-items: flex-start;" : ""}
`

export const ListCardDataCol = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
`

export const ListGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    grid-gap: 16px;
`

export const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const AnaliticsFilterToolbar = styled.div`
 flex: 1;
  flex-wrap: wrap; 
  display: flex;
   gap: 0.5em; 
   maxWidth: 100%;
    margin-bottom:0.5em;
`